import { Component, OnInit, OnDestroy } from '@angular/core';
import { LocationService } from '../../../@core/services/location.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'locations-map',
  templateUrl: './locations-map.component.html',
  styleUrls: ['./locations-map.component.scss']
})
export class LocationsMapComponent implements OnInit, OnDestroy {
  // google maps zoom level
  zoom: number = 16;
  // initial center position for the map
  lat: number = 45.500922;
  lng: number = -73.443143;
  sub: Subscription;
  constructor(public _locationService: LocationService) {}

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit() {
    this._locationService.setLocation({
      Latitude: this.lat,
      Longitude: this.lng,
      zoom: 12
    });

    this.sub = this._locationService.locationSubject.subscribe((data) => {
      this.lat = data.Latitude;
      this.lng = data.Longitude;
      this.zoom = data.zoom;
      this.zoomIn();
    });
  }

  zoomIn() {
    const intervalZoom = setInterval(() => {
      this.zoom = this.zoom + 1;
      //if (this.zoom > 15) {
      clearInterval(intervalZoom);
      //}
    }, 100);
  }
}
